import { FileChild, HeadingLevel, Paragraph, TextRun } from 'docx';
import { ElearningDataType } from '@/modules/types/elearning';
import {
  formatSummaryDate,
  htmlContentHandler,
  keyValuePairParagraph as keyValuePairTextRun,
  CONTENT_EMPTY,
} from './common';

export function handleElearningData(
  elearningData: ElearningDataType,
): FileChild[] {
  const title = elearningData.name || `Untitled module ${elearningData.id}`;
  const description = elearningData.description?.trim()
    ? htmlContentHandler(elearningData.description)
    : [new Paragraph({ text: CONTENT_EMPTY })];

  const categoriesText =
    elearningData.categories
      ?.map((c) => c.name)
      .filter(Boolean)
      .join(', ') || CONTENT_EMPTY;

  const reviewersText =
    elearningData.reviewers
      ?.map((r) => {
        const fromMeta = [
          r.reviewerMetadata?.firstName,
          r.reviewerMetadata?.lastName,
        ]
          .filter(Boolean)
          .join(' ')
          .trim();
        return fromMeta || r.name?.trim() || '';
      })
      .filter(Boolean)
      .join(', ') || CONTENT_EMPTY;

  const elearningContent: FileChild[] = [
    new Paragraph({
      text: title,
      heading: HeadingLevel.HEADING_1, // main heading
    }),
    new Paragraph({
      text: 'Summary',
      heading: HeadingLevel.HEADING_2, // Sub-heading
    }),
    // Summary contents
    new Paragraph({
      children: keyValuePairTextRun(
        'Date created: ',
        formatSummaryDate(elearningData.createdAt) || CONTENT_EMPTY,
      ),
    }),
    new Paragraph({
      children: keyValuePairTextRun(
        'Last modified: ',
        formatSummaryDate(elearningData.modifiedAt) || CONTENT_EMPTY,
      ),
    }),
    new Paragraph({
      children: keyValuePairTextRun(
        'Published to live: ',
        formatSummaryDate(elearningData.publishedToLiveAt) || 'Not published',
      ),
    }),
    new Paragraph({
      children: keyValuePairTextRun(
        'Published to review: ',
        formatSummaryDate(elearningData.publishedToReviewAt) || 'Not published',
      ),
    }),
    new Paragraph({
      children: keyValuePairTextRun('Categories: ', categoriesText),
    }),
    new Paragraph({
      children: keyValuePairTextRun('Reviewers: ', reviewersText),
    }),
    new Paragraph({
      children: [new TextRun({ text: 'Description: ', bold: true })],
    }), // description is a rich text
    ...description,
  ];

  return elearningContent;
}
